export default {
  pri: "#2DB49E",
  sec: "#00C7B8",
  white: "#fff",
  error: "#f84f31"
};
